import { render, staticRenderFns } from "./default.vue?vue&type=template&id=fdb91420&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "~/assets/admin/scss/style.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./default.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Sidebar: require('/app/components/admin/Sidebar/Sidebar.vue').default,Breadcrumb: require('/app/components/admin/Breadcrumb.vue').default})
